"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRegisteredDropTarget = useRegisteredDropTarget;

var _indexJs = require("../../internals/index.js");

var _useDragDropManagerJs = require("../useDragDropManager.js");

var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");

var _useAcceptJs = require("./useAccept.js");

var _useDropTargetJs = require("./useDropTarget.js");

function useRegisteredDropTarget(spec, monitor, connector) {
  var manager = (0, _useDragDropManagerJs).useDragDropManager();
  var dropTarget = (0, _useDropTargetJs).useDropTarget(spec, monitor);
  var accept = (0, _useAcceptJs).useAccept(spec);
  (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(function registerDropTarget() {
    var _registerTarget = (0, _indexJs).registerTarget(accept, dropTarget, manager),
        _registerTarget2 = _slicedToArray(_registerTarget, 2),
        handlerId = _registerTarget2[0],
        unregister = _registerTarget2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [manager, monitor, dropTarget, connector, accept.map(function (a) {
    return a.toString();
  }).join('|')]);
}